import React, { useEffect, useRef, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap';

const UpdateEmailPhoneInputField = ({
    labelName,
    value,
    isVerified,
    onClick,
    handleDirectlyResendCode,
    onFocus
}) => {

    const [showPassword, setShowPassword] = useState(true);
    const [activated, setActivated] = useState(true);
    const labelRef = useRef(null);
    const [coverWidth, setCoverWidth] = useState(0);
    useEffect(() => {
        setCoverWidth(
            labelRef.current ? labelRef.current.getBoundingClientRect().width + 9 : 0
        );
    }, [labelRef, value]);

    function handleShowPassword() {
        setShowPassword(!showPassword);
    }

    // console.log(value, "value in updateEmailPhoneInputField"); 

    return (
        <div className={`${isVerified || (value != "-" && value != "") ? "mb-4" : 'mb-3'}`} style={{ width: '100%' }}>
            <div className="input-group" style={{ transform: "none" }}>
                <div className='align-items-center d-flex justify-content-end w-100 fw-bold'>
                    {isVerified ?
                        <span style={{ color: '#07cd07', fontSize: '9px' }}>Verified <i class="bi bi-patch-check-fill"></i></span> :
                        value != "-" && value != "" && <span onClick={handleDirectlyResendCode} style={{ color: 'red', fontSize: '9px', cursor: 'pointer' }}>Not Verified (Click here to verify) <i class="bi bi-patch-exclamation-fill"></i></span>
                    }
                </div>
                <InputGroup
                    onFocus={() => {
                        setActivated(true);
                    }}>
                    <Form.Control
                        className="passwordFieldLeft"
                        // placeholder={placeholderName}
                        type={"text"}
                        value={value}
                        onChange={()=>{}}
                        // onBlur={onBlurCheckInput}
                        onFocus={onFocus}
                    />
                    <label
                        className={`${activated
                            ? "textfield-label-activated"
                            : "textfield-label-unactivated"
                            } textfield-label`}
                        ref={labelRef}
                        onClick={() => {
                            setActivated(true);
                        }}>
                        <span>
                            <strong>{labelName} </strong>

                        </span>
                    </label>
                    <div
                        className={`${activated
                            ? "textfield-label-cover-activated"
                            : "textfield-label-cover-unactivated"
                            } textfield-label-cover`}
                        style={{ width: coverWidth }}
                    />


                    <InputGroup.Text
                        className="passwordFieldRight"
                        onClick={onClick}>
                        {isVerified ? (
                            <span className='text-blue font-w600'>{"Update"}</ span>
                        ) : (<>
                            {(value == "-" ) ?  <span className='text-blue font-w600'>{"Add"}</ span> : <span className='text-blue font-w600'>{"Edit"}</ span> }
                        </>)}
                    </InputGroup.Text>
                </InputGroup>
            </div>
        </div>
    )
}

export default UpdateEmailPhoneInputField